import type { FC, ReactNode } from "react";

import type { IPlainTooltipProps } from "@similarweb/ui-components";

export type ILegendItem = {
    isGAVerified?: boolean;
    isGAPrivate?: boolean;
    metric?: string;
    isWinner?: boolean;
    data?: any;
    subtitleText?: string;
    format?: string;
    visible?: boolean;
    gridRowGap?: string;
    isSegment?: boolean;
    hidden?: boolean;
    color?: string;
    showLegendData?: boolean;
    name?: ReactNode;
    id?: string;
    isDisabled?: boolean;
    tooltip?: ReactNode;
    tooltipProps?: IPlainTooltipProps;
    infoTooltip?: string;
    isBeta?: boolean;
    setOpacity?: boolean;
    shouldPresentSeparatorAboveThisItem?: boolean;
    favicon?: string;
    tag?: string;
    customLegendComponent?: FC<unknown>;
    legendComponentWrapper?: ReactNode;
};

export type ILegendItems = Array<ILegendItem>;

export enum EGridDirections {
    ROW = "row",
    COLUMN = "column",
}

export interface ILegendProps {
    textMaxWidth?: string;
    subtitleMaxWidth?: string;
    legendItems: ILegendItems;
    legendsGap?: string;
    showLegendsData?: boolean;
    legendComponent?: FC<any>;
    gridDirection?: EGridDirections | string;
    legendComponentWrapper?: any;
    displayNA?: boolean;
    scrollContainerHeight?: string;
    favicon?: string;

    toggleSeries(legendItem: any, hidden: boolean, event: MouseEvent, reRenderLegendsComponent?: any): void; // to edit => remove any
}
